"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getForegroundColor = exports.getBorderColor = exports.DEFAULT_THRESHOLD_COLOR_KEY = exports.BACKGROUND_COLOR_KEY = void 0;

var _statusIndicator = require("../status-indicator");

var BACKGROUND_COLOR_KEY = 'neutral0';
exports.BACKGROUND_COLOR_KEY = BACKGROUND_COLOR_KEY;
var DEFAULT_THRESHOLD_COLOR_KEY = 'neutral50';
exports.DEFAULT_THRESHOLD_COLOR_KEY = DEFAULT_THRESHOLD_COLOR_KEY;

var getForegroundColor = function getForegroundColor(status, selectors) {
  switch (status) {
    case _statusIndicator.Status.Warning:
      return selectors.color('yellow70');

    case _statusIndicator.Status.Negative:
      return selectors.color('red70');

    case _statusIndicator.Status.Positive:
      return selectors.color('green70');

    case _statusIndicator.Status.Loading:
      return selectors.color('primary70');

    default:
      return selectors.color('neutral70');
  }
};

exports.getForegroundColor = getForegroundColor;

var getBorderColor = function getBorderColor(status, selectors) {
  switch (status) {
    case _statusIndicator.Status.Warning:
      return selectors.color('yellow80');

    case _statusIndicator.Status.Negative:
      return selectors.color('red80');

    case _statusIndicator.Status.Positive:
      return selectors.color('green80');

    case _statusIndicator.Status.Loading:
      return selectors.color('primary80');

    default:
      return selectors.color('neutral90');
  }
};

exports.getBorderColor = getBorderColor;